module.exports = __webpack_public_path__ + "static/media/image_6x2.82e3a1bd.png";